import angular from 'angular';
import uiRouter from 'angular-ui-router';
import modal from 'angular-ui-bootstrap/src/modal';
import transactionDetailsComponent from './transaction-details.component';
import datepickerPopup from 'angular-ui-bootstrap/src/datepickerPopup'

let transactionDetailsModule = angular.module('transactionDetails', [
  uiRouter,
  modal,
  datepickerPopup
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $stateProvider.state('quickbooks-transaction-details', {
    parent: 'app',
    url: '/admin/integrations/quickbooks/transaction/:transactionId',
    data: {
      pageHeader: true,
      pageTitle: 'Expense',
      pageDesc: 'QuickBooks transaction',
      breadcrumbLink: 'quickbooks-transaction',
      breadcrumbText: 'Transaction Search'
    },
    template: '<transaction-details></transaction-details>'
  })

})

.component('transactionDetails', transactionDetailsComponent);

export default transactionDetailsModule;



// WEBPACK FOOTER //
// ./client/pages/admin/integrations/quickbooks/capabilities/transaction-details/transaction-details.js